import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Button } from '@pushpay/button';
import { SuccessIcon, CrossIcon, LoadingOvalIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { usePrevious } from '@pushpay/utils';
import ExportTitle from './export-title';
import useSharedStyles from './use-styles';

const CompletedJob = props => {
  const {
    classes: classesProp,
    'data-pp-at-target': targetId,
    job,
    createDownloadUrl,
    downloadUrl,
    onDismiss,
    translate
  } = props;
  const {
    completedOn,
    size,
    jobKey,
    filename,
    isNew,
    type,
    customTitle,
    customSubtext
  } = job;
  const sharedClasses = useSharedStyles(classesProp);
  const [isCreatingUrl, setIsCreatingUrl] = useState(false);
  const [isDismissing, setIsDismissing] = useState(false);
  const fileLink = useRef(null);
  const previewDownloadUrl = usePrevious(downloadUrl);
  const handleDownload = useCallback(() => {
    setIsCreatingUrl(true);
    createDownloadUrl(jobKey);
  }, [job, createDownloadUrl]);
  useEffect(function triggerDownloadAfterUrlCreated() {
    if (!isCreatingUrl || !downloadUrl || downloadUrl === previewDownloadUrl || !fileLink.current) return;
    fileLink.current.click();
    setIsCreatingUrl(false);
  }, [isCreatingUrl, downloadUrl, previewDownloadUrl]);
  const handleDismiss = useCallback(() => {
    setIsDismissing(true);
    onDismiss(jobKey);
  }, [job, onDismiss]);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(sharedClasses.itemRoot, isNew ? sharedClasses.newItem : '')
  }, downloadUrl && /*#__PURE__*/React.createElement("a", {
    download: true,
    className: sharedClasses.downloadLink,
    href: downloadUrl,
    ref: fileLink
  }, "download link"), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemStatusIconContainer
  }, /*#__PURE__*/React.createElement(SuccessIcon, {
    className: sharedClasses.successIcon,
    "data-pp-at-target": `${targetId}-success-icon`
  })), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemMainInfoWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemMainInfo
  }, /*#__PURE__*/React.createElement("div", {
    title: filename !== null && filename !== void 0 ? filename : '',
    className: sharedClasses.itemFileName
  }, customTitle && typeof customTitle === 'function' ? customTitle(jobKey, type, completedOn, filename, isNew) : customTitle && /*#__PURE__*/React.createElement(ExportTitle, {
    titleText: customTitle.titleText,
    titleSubtext: customTitle.titleSubtext,
    "data-pp-at-target": `${targetId}-completed-custom-export-title`
  }) || filename), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.subText
  }, customSubtext && typeof customSubtext === 'function' ? customSubtext(jobKey, type, completedOn, filename, isNew) : !!customSubtext && customSubtext || /*#__PURE__*/React.createElement(React.Fragment, null, `${Math.round(size / 1000)} Kbs`, ' ', completedOn && /*#__PURE__*/React.createElement("span", {
    className: sharedClasses.timestamp
  }, "(", completedOn, ")"))))), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemActionWrap
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleDownload,
    type: "button",
    disabled: isCreatingUrl,
    displayStyle: "text",
    "data-pp-at-target": `${targetId}-download-btn`
  }, translate('downloadsPanel.download'), isCreatingUrl && /*#__PURE__*/React.createElement(LoadingOvalIcon, {
    className: sharedClasses.btnLoadingSpinner,
    "data-pp-at-target": `${targetId}-loading-icon`
  }))), !isCreatingUrl && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    title: translate('downloadsPanel.dismiss'),
    className: sharedClasses.dismissItemBtn,
    onClick: handleDismiss,
    disabled: isDismissing,
    "data-pp-at-target": `${targetId}-dismiss-button`
  }, isDismissing ? /*#__PURE__*/React.createElement(LoadingOvalIcon, {
    "data-pp-at-target": `${targetId}-loading-icon`
  }) : /*#__PURE__*/React.createElement(CrossIcon, {
    "data-pp-at-target": `${targetId}-close-icon`
  })));
};

export default CompletedJob;